import { withResourceState } from '@kinet-open-network/client/shared/data-access/state';
import { withTasksOptions } from '@kinet-open-network/client/tasks/data-access';
import { signalStore } from '@ngrx/signals';
import { CustomerTasksService } from '../services/customer-tasks.service';

export const CustomerTasksStore = signalStore(
  { protectedState: false },
  withResourceState(CustomerTasksService),
  withTasksOptions(),
);
